export default "__VITE_ASSET__gcdXMjam__"